import React from 'react'
import PropTypes from 'prop-types'
import CurrentHeadCountSummaryReport from './CurrentHeadCountSummaryReport'
import Graph from '../../OrganisationalCompensation/Graph'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import { range, get, find } from 'lodash'
import { Paper } from '@material-ui/core'
import { useStyles } from '../styles'

export default function CurrentHeadCountSummary(props) {
    const classes = useStyles();
    const groups = ['E', 'M', 'P', 'S']

    const groupsNames = {
        'E': 'Executive',
        'M': 'Management',
        'P': 'Professional',
        'S': 'Support',
    }

    const categoryFilters = {
        'executive': true,
        'management': true,
        'professional': true,
        'support': true
    }

    const onApply = (filters) => {
        props.onApply(filters, 'WorkforceCurrentHeadCountSummary')
    }

    const levelsData = []
    const groupSummary = {}
    const groupTotal = {
        current: {
            totalN: 0,
            totalPercent: 0,
        }
    }

    range(14).forEach(level => {
        const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
        const groupData = {}
        groups.forEach(g => {
            groupData[g] = {
                level: '',
                title: '',
                current: { n: '', percent: '', salary: '' },
            }
        })

        groupSummary[level] = {
            current: { nSummary: 0, percentSummary: 0 },
        }

        levelData.forEach(ld => {
            const groupKey = ld.job_grade.slice(0, 1)
            const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

            groupData[groupKey].level = ld.job_grade
            groupData[groupKey].title = ld.job_title

            if (dataInReport) {
                groupSummary[level].current.nSummary += dataInReport ? dataInReport.total : 0
            }
        })
        groupTotal.current.totalN += groupSummary[level].current.nSummary;
        levelsData.push(groupData)
    })

    range(14).forEach(level => {
        groupSummary[level].current.percentSummary = round((groupSummary[level].current.nSummary / groupTotal.current.totalN) * 100)
        groupTotal.current.totalPercent = round(groupTotal.current.totalPercent + groupSummary[level].current.percentSummary)
        groupSummary[level].current.percentSummary = groupSummary[level].current.percentSummary.toFixed(1)
    })

    groupTotal.current.totalPercent = round(groupTotal.current.totalPercent, 0)

    const groupsForGraphs = []
    for (const categoryKey in categoryFilters) {
        if (get(categoryFilters, categoryKey, false)) {
            groupsForGraphs.push(categoryKey.substr(0, 1).toUpperCase())
        }
    }

    const graphsDataByGrades = []
    Object.keys(groupSummary).forEach(grade => {
        graphsDataByGrades[grade] = { title: grade, count: groupSummary[grade].current.nSummary }
    })

    return (
        <React.Fragment>
            <div>
                <Paper>
                    <DataFilters
                        fetchedFilterData={props.fetchedFilterData}
                        filtersData={props.filtersData}
                        onDataFilterSelect={props.onDataFilterSelect}
                        componentName={'WorkforceCurrentHeadCountSummary'}
                        reportFilters={props.reportFilters}
                        onApply={onApply}
                        resetFilter={props.resetFilter}
                        reportFiltersType={props.reportFiltersType}
                        reportDataChanged={props.reportDataChanged}
                    />
                    <div className={classes.container}>
                        <CurrentHeadCountSummaryReport groupTotal={groupTotal} groupSummary={groupSummary} groups={groups} groupsNames={groupsNames} levelsData={levelsData} />
                        <div className={classes.graphContainer}>
                            <Graph
                                data={graphsDataByGrades}
                                height={'450px'}
                                width={'700px'}
                                chartArea={{ 'width': '70%', 'height': '70%' }}
                                vAxisTitle={'Global Grades'}
                            ></Graph>
                        </div>
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    )
}

CurrentHeadCountSummary.propTypes = {
    masterData: PropTypes.object.isRequired,
    onDataFilterSelect: PropTypes.func.isRequired,
    reportFilters: PropTypes.object.isRequired,
    reportData: PropTypes.array.isRequired,
    onApply: PropTypes.func.isRequired,
}
